import { Injectable } from '@angular/core';
import { InterpolationParameters, MissingTranslationHandler, MissingTranslationHandlerParams, TranslateParser } from '@ngx-translate/core';

// Source keys are already English. If even backend English is unavailable,
// keep values such as prices/counts interpolated without a local dictionary.
@Injectable()
export class SourceKeyFallback implements MissingTranslationHandler {
  constructor(private readonly parser: TranslateParser) {}

  handle(params: MissingTranslationHandlerParams): string {
    return this.parser.interpolate(params.key, params.interpolateParams as InterpolationParameters) ?? params.key;
  }
}
